module.exports = __webpack_public_path__ + "500e0151baed0ce7305e4acbb94aaf6d.png";